// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-tUA","comment":"styles_comment__3qsfy"};